import "@hotwired/turbo-rails"
import "./controllers"
import "./app"
import "./config"
import "./vendor.min";
import "./bill"
import "./bill_form"
import "./contract_note"
import "./preview"
import "./wallet"
import "./item_fields"
import "bootstrap"


document.addEventListener("turbo:load", function () {
  const dateField = document.querySelector("input[type='date']");
  document.querySelectorAll("input[type='date']").forEach(function(dateField) {
    dateField.addEventListener("click", function () {
      this.showPicker && this.showPicker();
    });
  });

  const openSidebarBtn = document.getElementById("openSidebarBtn");
  const closeSidebarBtn = document.getElementById("closeSidebarBtn");
  const filterSidebar = document.getElementById("filterSidebar");

  openSidebarBtn.addEventListener("click", function() {
    filterSidebar.classList.add("active");
  });

  closeSidebarBtn.addEventListener("click", function() {
    filterSidebar.classList.remove("active");
  });
});
